import { Link } from 'react-router-dom'
import styled from 'styled-components'

import { BORDER, BUTTON_BG, BUTTON_HOVER_BG, DIVIDER, MUTED_TEXT, SURFACE, TEXT, TONES, VALUE_TEXT } from '../../colors'

export const StyledCard = styled.section`
  min-width: 0;
  background: ${SURFACE};
  border: 1px solid ${BORDER};
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
`

export const StyledDangerCard = styled(StyledCard)`
  border-color: #f3c1bc;

  h3 {
    color: ${TONES.error.fg};
  }
`

export const StyledCardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 18px 24px;
  border-bottom: 1px solid ${BORDER};

  h3 {
    margin: 0;
    color: ${TEXT};
    font-size: 18px;
    font-weight: 700;
  }
`

export const StyledCardBody = styled.div`
  padding: 4px 0;
`

export const StyledRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px 24px;
  padding: 14px 24px;

  & + & {
    border-top: 1px solid ${DIVIDER};
  }
`

export const StyledRowText = styled.div`
  display: flex;
  flex: 1 1 220px;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
`

export const StyledRowLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: ${TEXT};
  font-size: 15px;
  font-weight: 500;
`

export const StyledRowDescription = styled.div`
  color: ${MUTED_TEXT};
  font-size: 13px;
`

export const StyledRowValue = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  color: ${VALUE_TEXT};
  font-size: 14px;
`

export const StyledValueDivider = styled.span`
  width: 1px;
  height: 32px;
  background: ${BORDER};
`

export const StyledLinkButton = styled(Link)`
  display: inline-flex;
  align-items: center;
  height: 36px;
  padding: 0 16px;
  border-radius: 6px;
  background: ${BUTTON_BG};
  color: ${TEXT};
  font-size: 14px;
  font-weight: 600;
  text-decoration: none;
  white-space: nowrap;

  &:hover,
  &:focus-visible {
    background: ${BUTTON_HOVER_BG};
    color: ${TEXT};
  }
`

export const StyledPageHeading = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  h2 {
    margin: 0;
    color: ${TEXT};
    font-size: 22px;
    font-weight: 700;
  }

  p {
    margin: 0;
    color: ${MUTED_TEXT};
    font-size: 14px;
  }
`

export const StyledPage = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  min-width: 0;
`

export const StyledRowsTable = styled.table`
  width: 100%;
  border-collapse: collapse;

  th,
  td {
    padding: 14px 24px;
    vertical-align: middle;
  }

  th {
    width: 45%;
    min-width: 200px;
    font-weight: 400;
    text-align: left;

    > * + * {
      margin-top: 3px;
    }
  }

  td {
    color: ${VALUE_TEXT};
    font-size: 14px;
  }

  @media (max-width: 720px) {
    th,
    td {
      display: block;
      width: auto;
    }

    th {
      padding-bottom: 6px;
    }

    td {
      padding-top: 0;
    }
  }
`

export const StyledRowControl = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 12px 16px;

  @media (max-width: 720px) {
    justify-content: flex-start;
  }
`

export const StyledCardContent = styled.div`
  padding: 16px 24px 20px;
`
